// extracted by mini-css-extract-plugin
export var formContainer = "_ig-0";
export var message = "_ig-1";